import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.reset()
  }

  reset() {
    // Cached pages should also render their open sections at full height.
    this.element.querySelectorAll("[data-main-menu-animate]").forEach(panel => {
      panel.removeAttribute("data-main-menu-animate")
    })
  }

  animate(event) {
    // Bootstrap emits this before changing .show, including for nested menus.
    event.target.setAttribute("data-main-menu-animate", "")
  }
}
